var _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12C0 18.6 5.4 24 12 24C18.6 24 24 18.6 24 12C24 5.4 18.6 0 12 0ZM17.04 9.96L11.28 15.72C10.8 16.2 10.08 16.2 9.6 15.72L6.96 13.08C6.48 12.6 6.48 11.88 6.96 11.4C7.44 10.92 8.16 10.92 8.64 11.4L10.44 13.2L15.36 8.28C15.84 7.8 16.56 7.8 17.04 8.28C17.52 8.76 17.52 9.48 17.04 9.96Z",
    fill: "#D31104"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.16797,
    y: 4.18994,
    width: 14.3022,
    height: 14.6064,
    fill: "#D31104"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4838 9.82881C13.4838 10.7193 13.4508 11.5494 13.3848 12.3189C13.3189 13.0885 13.2309 13.8691 13.121 14.6606H11.241C11.1311 13.8691 11.0376 13.0885 10.9607 12.3189C10.8947 11.5494 10.8617 10.7193 10.8617 9.82881V6.87695H13.4838V9.82881ZM13.6982 17.0023C13.6982 17.4861 13.5387 17.8598 13.2199 18.1237C12.9121 18.3876 12.5603 18.5195 12.1645 18.5195C11.7687 18.5195 11.4114 18.3876 11.0926 18.1237C10.7848 17.8598 10.6309 17.4861 10.6309 17.0023C10.6309 16.5186 10.7848 16.1448 11.0926 15.8809C11.4114 15.6171 11.7687 15.4852 12.1645 15.4852C12.5603 15.4852 12.9121 15.6171 13.2199 15.8809C13.5387 16.1448 13.6982 16.5186 13.6982 17.0023Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.e5d7bee6.svg";
export { ForwardRef as ReactComponent };